import { normalizeText } from "../../../shared/util/normalizeText";
import { FinancingBanks } from "../../../shared/data/types";

export const getFinancingBankName = (bank: FinancingBanks) => {
  const normBank = normalizeText(bank) as
    | "btg"
    | "btg pactual"
    | "itau"
    | "sol agora"
    | "solagora"
    | "solfacil"
    | "losango"
    | "santander"
    | "bv financeira"
    | "bv"
    | "revo"
    | "azume cred"
    | "azumecred"
    | "azumecredi"
    | "azume credi";

  switch (normBank) {
    case "btg":
      return "BTG";

    case "btg pactual":
      return "BTG";

    case "itau":
      return "Itaú";

    case "sol agora":
      return "Sol Agora";

    case "solagora":
      return "Sol Agora";

    case "solfacil":
      return "Solfácil";

    case "losango":
      return "Losango";

    case "santander":
      return "Santander";

    case "bv financeira":
      return "BV Financeira";

    case "bv":
      return "BV Financeira";

    case "revo":
      return "Revo";

    default:
      return "Azume Cred";
  }
};
